import React from "react";
import GoBackButton from "../../components/GoBackButton";
import Header from "../../components/Header";

export default props => {
    return (
        <div>
            <Header/>
            <section className="text-based ">
                <div className="row">
                <div className="pdr">
                    <GoBackButton/>
                    <h3>PRIVACY NOTICE</h3>
                    <h5>
                    Last updated June 07, 2021 <br />
                    Thank you for choosing to be part of our community at Solyd Floors, 
                    LLC, doing business as Solyd Floors (“ “, “we”, “us”, “our”). We are 
                    committed to protecting your personal information and your right to 
                    privacy. If you have any questions or concerns about this privacy 
                    notice, or our practices with regards to your personal information, 
                    please contact us at admin@solydfloors.com.
                    When you visit our website <a href="https://www.solydfloors.com">https://www.solydfloors.com</a> (the 
                    “Website”), and more generally, use any of our services (the 
                    “Services”, which include the Website), we appreciate that you are 
                    trusting us with your personal information. We take your privacy very 
                    seriously. <br />
                    In this privacy notice, we seek to explain to you in the clearest way 
                    possible what information we collect, how we use it and what rights 
                    you have in relation to it. We hope you take some time to read through 
                    it carefully, as it is important. If there are any terms in this privacy 
                    notice that you do not agree with, please discontinue use of our 
                    Services immediately. <br />
                    This privacy notice applies to all information collected through our 
                    Services (which, as described above, includes our Website), as well as, 
                    any related services, sales, marketing or events.
                    Please read this privacy notice carefully as it will help you understand 
                    what we do with the information that we collect. <br />
                    TABLE OF CONTENTS <br />
                    1. WHAT INFORMATION DO WE COLLECT? <br />
                    2. HOW DO WE USE YOUR INFORMATION? <br />
                    3. WILL YOUR INFORMATION BE SHARED WITH ANYONE? <br />
                    4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES? <br />
                    5 HOW LONG PO WE KEEP YOUR INFORMATION? <br />
                    6. HOW DO WE KEEP YOUR INFORMATION SAFE? <br />
                    7. WHAT ARE YOUR PRIVACY RIGHTS? <br />
                    8 CONTROLS FOR DO-NOT-TRACK FEATURES <br />
                    9. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS? <br />
                    10. DO WE MAKE UPDATES TO THIS NOTICE? <br />
                    11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE? <br />
                    12. HOW CAN YOU REVIEW, UPDATE OR DELETE THE DATA WE 
                    COLLECT FROM YOU? <br /><br />
                    1. WHAT INFORMATION DO WE COLLECT? <br />
                    Personal information you disclose to us
                    In Short: We collect personal information that you provide to us.
                    We collect personal information that you voluntarily provide to us when 
                    you register on the Website, express an interest in obtaining 
                    information about our products and Services, when you participate in 
                    activities on the website or otherwise when you contact us.
                    The personal information that we collect depends on the context of 
                    your interactions with us and the Website, the choices you make and 
                    the products and features you use. The personal information we 
                    collect may include the following:
                    Personal Information Provided by You. We collect names; phone 
                    numbers; email addresses; mailing addresses; billing addresses; debit/
                    credit card numbers; contact or authentication data; contact 
                    preferences; job titles; usernames; passwords; and other similar 
                    information. <br />
                    Payment Data. We may collect data necessary to process your 
                    payment if you make purchases, such as your payment instrument 
                    number (such as a credit card number), and the security code 
                    associated with your payment instrument. All payment data is stored 
                    by Poynt. You may find their privacy notice link(s) here:
                    <a href="https://www.poynt.com/privacy">https://www.poynt.com/privacy</a>
                    All personal information that you provide to us must be true, complete 
                    and accurate, and you must notify us of any changes to such personal 
                    information. <br />
                    2. HOW DO WE USE YOUR INFORMATION? <br />
                    In Short: We process your information for purposes based on 
                    legitimate business interests, the fulfillment of our contract with you, 
                    compliance with our legal obligations, and/or your consent.
                    We use personal information collected via our Website for a variety of 
                    business purposes described below. We process your personal 
                    information for these purposes in reliance on our legitimate business 
                    interests, in order to enter into or perform a contract with you, with 
                    your consent, and/or for compliance with our legal obligations. We 
                    indicate the specific processing grounds we rely on next to each 
                    purpose listed below.
                    We use the information we collect or receive:
                    ■ To facilitate account creation and logon process. If you choose to 
                    link your account with us to a third-party account (such as your Google 
                    or Facebook account), we use the information you allowed us to 
                    collect from those third parties to facilitate account creation and logon 
                    process for the performance of the contract.
                    ■ To post testimonials. We post testimonials on our Website that may 
                    contain personal information. Prior to posting a testimonial, we will 
                    obtain your consent to use your name and the content of the 
                    testimonial. If you wish to update, or delete your testimonial, please 
                    contact us at dpo@solydfloors.com and be sure to include your name, 
                    testimonial location, and contact information. <br />
                    • Request feedback. We may use your information to request feedback 
                    and to contact you about your use of our Website. <br />
                    • To enable user-to-user communications. We may use your 
                    information in order to enable user-to-user communications with each 
                    user's consent. <br />
                    • To manage user accounts. We may use your information for the 
                    purposes of managing our account and keeping it in working order. <br />
                    ■ To send administrative information to you. We may use your 
                    personal information to send you product, service and new feature 
                    information and/or information about changes to our terms, conditions,  
                    and policies. <br />
                    • To protect our Services. We may use your information as part of our 
                    efforts to keep our Website safe and secure (for example, for fraud 
                    monitoring and prevention). <br />
                    ■ To enforce our terms, conditions and policies for business purposes, 
                    to comply with legal and regulatory requirements or in connection with 
                    our contract. <br />
                    • To respond to legal requests and prevent harm. If we receive a 
                    subpoena or other legal request, we may need to inspect the data we 
                    hold to determine how to respond. <br />
                    ■ Fulfill and manage your orders. We may use your information to fulfill 
                    and manage your orders, payments, returns, and exchanges made 
                    through the Website. <br />
                    ■ Administer prize draws and competitions. We may use your 
                    information to administer prize draws and competitions when you elect 
                    to participate in our competitions. <br />
                    ■ To deliver and facilitate delivery of services to the user. We may use 
                    your information to provide you with the requested service. <br />
                    ■ To respond to user inquiries/offer support to users. We may use your 
                    information to respond to your inquiries and solve any potential issues 
                    you might have with the use of our Services. <br />
                    ■ To send you marketing and promotional communications. We and/or 
                    our third-party marketing partners may use the personal information 
                    you send to us for our marketing purposes, if this is in accordance with 
                    your marketing preferences. For example, when expressing an interest 
                    in obtaining information about us or our Website, subscribing to 
                    marketing or otherwise contacting us, we will collect personal 
                    information from you. You can opt-out of our marketing emails at any 
                    time (see the 
                    "WHAT ARE YOUR PRIVACY RIGHTS?" below). <br />
                    ■ Deliver targeted advertising to you. We may use your information to 
                    develop and display personalized content and advertising (and work 
                    with third parties who do so) tailored to your interests and/or location 
                    and to measure its effectiveness. <br />
                    ■ For other business purposes. We may use your information for other 
                    business purposes, such as data analysis, identifying usage trends, 
                    determining the effectiveness of our promotional campaigns and to 
                    evaluate and improve our Website, products, marketing and your 
                    experience. We may use and store this information in aggregated and 
                    anonymized form so that it is not associated with individual end users 
                    and does not include personal information. We will not use identifiable 
                    personal information without your consent. <br />
                    3. WILL YOUR INFORMATION BE SHARED WITH ANYONE? <br />
                    In Short: We only share information with your consent, to comply with 
                    laws, to provide you with services, to protect your rights, or to fulfill 
                    business obligations.
                    We may process or share your data that we hold based on the 
                    following legal basis: <br />
                    ■ Consent: We may process your data if you have given us specific 
                    consent to use your personal information for a specific purpose. <br />
                    ■ Legitimate Interests: We may process your data when it is 
                    reasonably necessary to achieve our legitimate business interests. <br />
                    ■ Performance of a Contract: Where we have entered into a contract 
                    with you, we may process your personal information to fulfill the terms 
                    of our contract. <br />
                    ■ Legal Obligations: We may disclose your information where we are 
                    legally required to do so in order to comply with applicable law, 
                    governmental requests, a judicial proceeding, court order, or legal 
                    process, such as in response to a court order or a subpoena (including 
                    in response to public authorities to meet national security or law 
                    enforcement requirements). <br />
                    ■ Vital Interests: We may disclose your information where we believe it 
                    is necessary to investigate, prevent, or take action regarding potential 
                    violations of our policies, suspected fraud, situations involving 
                    potential threats to the safety of any person and illegal activities, or as 
                    evidence in litigation in which we are involved.
                    More specifically, we may need to process your data or share your 
                    personal information in the following situations: <br />
                    ■ Business Transfers. We may share or transfer your information in 
                    connection with, or during negotiations of, any merger, sale of 
                    company assets, financing, or acquisition of all or a portion of our 
                    business to another company. <br />
                    ■ Google Maps Platform APis. We may share your information with 
                    certain Google Maps Platform APls (e.g., Google Maps API, Place API). 
                    To find out more about Google's Privacy Policy, please refer to this 
                    link. <br />
                    ■ Affiliates. We may share your information with our affiliates, in which 
                    case we will require those affiliates to honor this privacy notice. 
                    Affiliates include our parent company and any subsidiaries, joint 
                    venture partners or other companies that we control or that are under 
                    common control with us. <br />
                    ■ Business Partners. We may share your information with our business 
                    partners to offer you certain products, services or promotions. <br />
                    4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES? <br />
                    In Short: We may use cookies and other tracking technologies to 
                    collect and store your information.
                    We may use cookies and similar tracking technologies (like web 
                    beacons and pixels) to access or store information. Specific 
                    information about how we use such technologies and how you can 
                    refuse certain cookies is set out in our Cookie Notice. <br />
                    5. HOW LONG DO WE KEEP YOUR INFORMATION? <br />
                    In Short: We keep your information for as long as necessary to fulfill 
                    the purposes outlined in this privacy notice unless otherwise required 
                    by law. <br />
                    We will only keep your personal information for as long as it is 
                    necessary for the purposes set out in this privacy notice, unless a 
                    longer retention period is required or permitted by law (such as tax, 
                    accounting or other legal requirements). No purpose in this notice will 
                    require us keeping your personal information for longer than the period 
                    of time in which users have an account with us.
                    When we have no ongoing legitimate business need to process your 
                    personal information, we will either delete or anonymize such 
                    information, or, if this is not possible (for example, because your 
                    personal information has been stored in backup archives), then we will 
                    securely store your personal information and isolate it from any further 
                    processing until deletion is possible. <br />
                    6. HOW DO WE KEEP YOUR INFORMATION SAFE? <br />
                    In Short: We aim to protect your personal information through a 
                    system of organizational and technical security measures.
                    We have implemented appropriate technical and organizational 
                    security measures designed to protect the security of any personal 
                    information we process. However, despite our safeguards and efforts 
                    to secure your information, no electronic transmission over the Internet 
                    or information storage technology can be guaranteed to be 100% 
                    secure, so we cannot promise or guarantee that hackers, 
                    cybercriminals, or other unauthorized third parties will not be able to 
                    defeat our security, and improperly collect, access, steal, or modify 
                    your information.
                    Although we will do our best to protect your personal information, 
                    transmission of personal information to and from our Website is at your 
                    own risk. You should only access the Website within a secure 
                    environment. <br />
                    7. WHAT ARE YOUR PRIVACY RIGHTS? <br />
                    In Short: You may review, change, or terminate your account at any 
                    time.
                    If you are a resident in the EEA or UK and you believe we are 
                    unlawfully processing your personal information, you also have the 
                    right to complain to your local data protection supervisory authority. 
                    You can find their contact details here:
                    http://ec.euroga.eu/justice/data-grotection/bodies/authorities/index 
                    en.htm.
                    If you are a resident in Switzerland, the contact details for the data 
                    protection authorities are available here: 
                    httiis://www,edoeb,admin,ch/edoeb/en/home,htm!.
                    If you have questions or comments about your privacy rights, you may 
                    email us at admin@solydfloors.com.
                    Account Information
                    If you would at any time like to review or change the information in 
                    your account or terminate your account, you can: <br />
                    • Log in to your account settings and update your user account. <br />
                    • Contact us using the contact information provided. <br />
                    Upon your request to terminate your account, we will deactivate or 
                    delete your account and information from our active databases. 
                    However, we may retain some information in our files to prevent fraud, 
                    troubleshoot problems, assist with any investigations, enforce our 
                    Terms of Use and/or comply with applicable legal requirements.
                    Cookies and similar technologies: Most Web browsers are set to 
                    accept cookies by default. If you prefer, you can usually choose to set 
                    your browser to remove cookies and to reject cookies. If you choose 
                    to remove cookies or reject cookies, this could affect certain features 
                    or services of our Website. To opt-out of interest-based advertising by <br />
                    advertisers on our Website visit:
                    <a href="http://www.aboutads.info/choices/">http://www.aboutads.info/choices/</a>. <br />
                    Opting out of email marketing
                    You can unsubscribe from our marketing email list at any time by 
                    clicking on the unsubscribe link in the emails that we send or by 
                    contacting us using the details provided below. You will then be 
                    removed from the marketing email list - however, we may still 
                    communicate with you, for example to send you service-related emails 
                    that are necessary for the administration and use of your account, to 
                    respond to service requests, or for other non-marketing purposes.  <br />
                    To otherwise opt-out, you may: <br />
                    •	Contact us using the contact information provided. <br />
                    •	Access your account settings and update your preferences. <br />
                    8. CONTROLS FOR DO-NOT-TRACK FEATURES <br />
                    Most web browsers and some mobile operating systems and mobile 
                    applications include a Do-Not-Track ("DNT") feature or setting you can 
                    activate to signal your privacy preference not to have data about your 
                    online browsing activities monitored and collected. At this stage no 
                    uniform technology standard for recognizing and implementing ONT 
                    signals has been finalized. As such, we do not currently respond to 
                    ONT browser signals or any other mechanism that automatically 
                    communicates your choice not to be tracked online. If a standard for 
                    online tracking is adopted that we must follow in the future, we will 
                    inform you about that practice in a revised version of this privacy 
                    notice. <br />
                    9. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS? <br />
                    In Short: Yes, if you are a resident of California, you are granted 
                    specific rights regarding access to your personal information.
                    California Civil Code Section 1798.83, also known as the "Shine The 
                    Light" law, permits our users who are California residents to request 
                    and obtain from us, once a year and free of charge, information about 
                    categories of personal information (if any) we disclosed to third parties 
                    for direct marketing purposes and the names and addresses of all third 
                    parties with which we shared personal information in the immediately 
                    preceding calendar year. If you are a California resident and would like 
                    to make such a request, please submit your request in writing to us 
                    using the contact information provided below.
                    If you are under 18 years of age, reside in California, and have a 
                    registered account with the Website, you have the right to request 
                    removal of unwanted data that you publicly post on the Website. To 
                    request removal of such data, please contact us using the contact 
                    information provided below, and include the email address associated 
                    with your account and a statement that you reside in California. We will 
                    make sure the data is not publicly displayed on the Website, but 
                    please be aware that the data may not be completely or 
                    comprehensively removed from all our systems (e.g. backups, etc.).
                    CCPA Privacy Notice <br />
                    The California Code of Regulations defines a "resident" as:
                    (1) every individual who is in the State of California for other than a 
                    temporary or transitory purpose and <br />
                    (2) every individual who is domiciled in the State of California who is 
                    outside the State of California for a temporary or transitory purpose
                    All other individuals are defined as "non-residents."
                    If this definition of "resident" applies to you, we must adhere to certain 
                    rights and obligations regarding your personal information.
                    What categories of personal information do we collect?
                    We may also collect other personal information outside of these 
                    categories instances where you interact with us in-person, online, or 
                    by phone or mail in the context of: <br />
                    ■ Receiving help through our customer support channels; <br />
                    ■ Participation in customer surveys or contests; and
                    ■ Facilitation in the delivery of our Services and to respond to your 
                    inquiries. <br />
                    How do we use and share your personal information? <br />
                    More information about our data collection and sharing practices can 
                    be found in this privacy notice.
                    You may contact us by email at admin@solydfloors.com, or by 
                    referring to the contact details at the bottom of this document.
                    If you are using an authorized agent to exercise your right to opt-out 
                    we may deny a request if the authorized agent does not submit proof 
                    that they have been validly authorized to act on your behalf.
                    Will your information be shared with anyone else? <br />
                    We may disclose your personal information with our service providers 
                    pursuant to a written contract between us and each service provider. 
                    Each service provider is a for-profit entity that processes the 
                    information on our behalf.
                    We may use your personal information for our own business purposes, 
                    such as for undertaking internal research for technological 
                    development and demonstration. <br />
                    This is not considered to be "selling" of your personal data. 
                    Solyd Floors, LLC has not disclosed or sold any personal information 
                    to third parties for a business or commercial purpose in the preceding 
                    12 months. Solyd Floors, LLC will not sell personal information in the 
                    future belonging to website visitors, users and other consumers.
                    Your rights with respect to your personal data
                    Right to request deletion of the data - Request to delete You can ask 
                    for the deletion of your personal information. If you ask us to delete 
                    your personal information, we will respect your request and delete your 
                    personal information, subject to certain exceptions provided by law, 
                    such as (but not limited to) the exercise by another consumer of his or 
                    her right to free speech, our compliance requirements resulting from a 
                    legal obligation or any processing that may be required to protect 
                    against illegal activities. <br />
                    Right to be informed - Request to know
                    Depending on the circumstances, you have a right to know: <br />
                    ■ whether we collect and use your personal information; <br />
                    ■ the categories of personal information that we collect; <br />
                    ■ the purposes for which the collected personal information is used; <br />
                    ■ whether we sell your personal information to third parties; <br />
                    ■ the categories of personal information that we sold or disclosed for a 
                    business purpose; <br />
                    ■ the categories of third parties to whom the personal information was 
                    sold or disclosed for a business purpose; and <br />
                    ■ the business or commercial purpose for collecting or selling personal 
                    information. <br />
                    In accordance with applicable law, we are not obligated to provide or 
                    delete consumer information that is de-identified in response to a 
                    consumer request or to re-identify individual data to verify a consumer  
                    request. <br />
                    Right to Non-Discrimination for the Exercise of a Consumer's Privacy 
                    Rights. <br />
                    We will not discriminate against you if you exercise your privacy rights. <br />
                    Verification
                    Upon receiving your request, we will need to verify your identity to 
                    determine you are the same person about whom we have the 
                    information in our system. These verification efforts require us to ask 
                    you to provide information so that we can match it with information 
                    you have previously provided us. <br />
                    For instance, depending on the type of request you submit, we may 
                    ask you to provide certain information so that we can match the 
                    information you provide with the information we already have on file, or 
                    we may contact you through a communication method (e.g., phone or 
                    email) that you have previously provided to us. 
                    We may also use other verification methods as the circumstances 
                    dictate. <br />
                    We will only use personal information provided in your request to verify 
                    your identity or authority to make the request. To the extent possible, 
                    we will avoid requesting additional information from you for the 
                    purposes of verification. If, however, we cannot verify your identity 
                    from the information already maintained by us, we may request that 
                    you provide additional information for the purposes of verifying your 
                    identity, and for security or fraud-prevention purposes. 
                    We will delete such additionally provided information as soon as we 
                    finish verifying you. <br />
                    Other Privacy Rights
                    ■ you may object to the processing of your personal data <br />
                    ■ you may request correction of your personal data if it is incorrect or 
                    no longer relevant, or ask to restrict the processing of the data <br />
                    ■ you can designate an authorized agent to make a request under the 
                    CCPA on your behalf. We may deny a request from an authorized 
                    agent that does not submit proof that they have been validly 
                    authorized to act on your behalf in accordance with the CCPA. <br />
                    ■ you may request to opt-out from future selling of your personal 
                    information to third parties. Upon receiving a request to opt-out, we 
                    will act upon the request as soon as feasibly possible, but no later than 
                    15 days from the date of the request submission. <br />
                    To exercise these rights, you can contact us by email at 
                    admin@solydfloors.com, or by referring to the contact details at the 
                    bottom of this document.  <br />
                    If you have a complaint about how we handle your data, we would like 
                    to hear from you. <br />
                    10. DO WE MAKE UPDATES TO THIS NOTICE? <br />
                    In Short: Yes, we will update this notice as necessary to stay compliant 
                    with relevant laws.
                    We may update this privacy notice from time to time. The updated 
                    version will be indicated by an updated "Revised" date and the 
                    updated version will be effective as soon as it is accessible. If we make 
                    material changes to this privacy notice, we may notify you either by 
                    prominently posting a notice of such changes or by directly sending 
                    you a notification. We encourage you to review this privacy notice 
                    frequently to be informed of how we are protecting your information.
                    11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE? <br />
                    If you have questions or comments about this notice, you may contact 
                    our Data Protection Officer (DPO), Sean Ramizi, by email at 
                    dpo@solydfloors.com, by phone at 8323308372, or by post to: <br />
                    Solyd Floors, LLC <br /> 
                    ATTN: Data Protection Officer <br />
                    7011 Calamo Street <br />
                    Suite 108 <br />
                    Springfield, VA 22150 <br />
                    United States <br /> <br />
                    12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE 
                    COLLECT FROM YOU? <br />
                    Based on the applicable laws of your country, you may have the right 
                    to request access to the personal information we collect from you, 
                    change that information, or delete it in some circumstances. 
                    To request to review, update, or delete your personal information, 
                    please submit a request form by clicking here.
                    </h5>
                </div>
                </div>
            </section>

        </div>
    )
}